<script>
  import router from 'page'
  import Header from './templates/main/Header.svelte'
  import Footer from './templates/main/Footer.svelte'

  var page
  var params

  function loadPage(module) {
    page = module.default
  }

  function loadParams(ctx, next) {
    params = ctx.params
    next()
  }

  router('/', () => import('./templates/main/Home.svelte').then(loadPage))
  router('/cart', () => import('./templates/main/Cart.svelte').then(loadPage))
  router('/checkout', () =>
    import('./templates/main/Checkout.svelte').then(loadPage),
  )
  router(
    '/rent/:tag',
    (ctx, next) => {
      params = ctx.params
      params.id = 1
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router(
    '/shop/:tag',
    (ctx, next) => {
      params = ctx.params
      params.id = 2
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router(
    '/rent',
    (ctx, next) => {
      params = ctx.params
      params.id = 1
      params.tag = ''
      params.sale = false
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router(
    '/shop',
    (ctx, next) => {
      params = ctx.params
      params.id = 2
      params.tag = ''
      params.sale = false
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router(
    '/accessories',
    (ctx, next) => {
      params = ctx.params
      params.id = 3
      params.tag = ''
      params.sale = false
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router('/gift-cards', () =>
    import('./templates/main/GiftCards.svelte').then(loadPage),
  )
  router(
    '/puzzle-packs',
    (ctx, next) => {
      params = ctx.params
      params.id = 4
      params.tag = ''
      params.sale = false
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router(
    '/puzzle-subscriptions',
    (ctx, next) => {
      params = ctx.params
      params.id = 5
      params.tag = ''
      params.sale = false
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router(
    '/sale',
    (ctx, next) => {
      params = ctx.params
      params.id = 2
      params.sale = true
      params.tag = ''
      next()
    },
    () => import('./templates/main/Products.svelte').then(loadPage),
  )
  router('/product/:title/sku/:id?', loadParams, () =>
    import('./templates/main/Product.svelte').then(loadPage),
  )

  router('/products/:id?', loadParams, () =>
    import('./templates/main/Products.svelte').then(loadPage),
  )

  router('/register', () =>
    import('./templates/account/Register.svelte').then(loadPage),
  )
  router('/reset', () =>
    import('./templates/account/ResetPass.svelte').then(loadPage),
  )
  router('/login', () =>
    import('./templates/account/Login.svelte').then(loadPage),
  )
  router('/logout', () =>
    import('./templates/account/Logout.svelte').then(loadPage),
  )
  router('/success', () =>
    import('./templates/main/Success.svelte').then(loadPage),
  )
  router('/account/:id?', loadParams, () =>
    import('./templates/account/Account.svelte').then(loadPage),
  )
  router('/ways-to-rent', () =>
    import('./templates/main/WaysToRentV2.svelte').then(loadPage),
  )
  router('/how-it-works', () =>
    import('./templates/main/HowItWorks.svelte').then(loadPage),
  )
  router('/gift-card/balance', () =>
    import('./templates/account/GiftCardBalance.svelte').then(loadPage),
  )
  router('/redeem', () =>
    import('./templates/account/RedeemGifted.svelte').then(loadPage),
  )
  // gifting memberships is retired; old links land on the redeem guide
  router('/gift', () => router.redirect('/redeem'))

  router('/info/:id?', loadParams, () =>
    import('./templates/main/Info.svelte').then(loadPage),
  )
  router('/blog/:id?', loadParams, () =>
    import('./templates/main/Blog.svelte').then(loadPage),
  )
  router('/events', loadParams, () =>
    import('./templates/main/Events.svelte').then(loadPage),
  )
  router('/event/:id', loadParams, () =>
    import('./templates/main/Event.svelte').then(loadPage),
  )
  router('*', () => import('./templates/NotFound.svelte').then(loadPage))

  router.start()
</script>

<style>
  .site-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: stretch;
  }

  main {
    flex: 1 0 auto;
  }
</style>

<div class="site-layout">
  <Header />
  <main>
    <svelte:component this={page} {params} />
  </main>
  <Footer />
</div>
